import { RcFile } from 'antd/es/upload';
import { ChunkStatus } from './types';
import UploadError from './UploadError';
export const upload = async (params: {
  url: string;
  file: File;
  headers?: Record<string, string>;
  signal?: AbortSignal;
  onProgress: (percent: number, file: any) => void;
}) => {
  const { url, file, headers, onProgress } = params;
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', url);
    if (headers) {
      Object.keys(headers).forEach((key) => {
        xhr.setRequestHeader(key, headers[key]);
      });
    }
    xhr.upload.onprogress = function (e) {
      onProgress(Math.round((e.loaded / e.total) * 100), file);
    };
    xhr.onload = function () {
      if (xhr.status === 200) {
        resolve(xhr.response);
      } else {
        reject(new UploadError('文件上传失败', file as RcFile, ChunkStatus.Error));
      }
    };
    xhr.send(file);
  });
};
